
export enum BudgetType {
    BUDGET = 'BUDGET',
    TS = 'TS',
}
